export default __webpack_public_path__ + "static/media/02.025f06f2.png";